import { useSyncExternalStore } from "react";
import type {
  RecordFamilyKey,
  RecordSubjectLink,
} from "@/features/forms/shared/record/record-family";

export interface ViewedRecord {
  family: RecordFamilyKey;
  recordId: string;
  subject: RecordSubjectLink | null;
}

let viewed: ViewedRecord | null = null;
const listeners = new Set<() => void>();

export function showViewedRecord(next: ViewedRecord | null): void {
  if (sameRecord(viewed, next)) return;
  viewed = next;
  for (const listener of listeners) listener();
}

export function useViewedRecord(): ViewedRecord | null {
  return useSyncExternalStore(subscribe, () => viewed);
}

function sameRecord(a: ViewedRecord | null, b: ViewedRecord | null): boolean {
  if (a === null || b === null) return a === b;
  return (
    a.family === b.family &&
    a.recordId === b.recordId &&
    a.subject?.kind === b.subject?.kind &&
    a.subject?.clientLinkId === b.subject?.clientLinkId
  );
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
